import { Action, createReducer, on } from '@ngrx/store';
import { decreaseLoading } from '../utils';
import * as DeviceActions from './devices.actions';
import { DeviceState } from './devices.models';
import { ChangedEvent, LinkChanged, RouterDto } from '../api/core';

export const devicesInitialState: DeviceState = {
    loading: 0,
    devices: [],
    totalCount: 0,
};

export const deviceReducer = createReducer<DeviceState>(
    devicesInitialState,
    on(DeviceActions.loading, (state) => {
        return { ...state, loading: state.loading + 1 };
    }),
    on(DeviceActions.loadingDone, (state) => {
        return { ...state, loading: decreaseLoading(state.loading) };
    }),
    on(DeviceActions.loadedDevices, (state, { data }) => {
        const entries = data.totalEntries ? data.totalEntries : data.entries ? data.entries.length : 0;
        return {
            ...state,
            devices: data.entries ? data.entries : [],
            totalCount: entries,
        };
    }),
    on(DeviceActions.updateDevice, (state, { event }) => {
        return {
            ...state,
            devices: state.devices.map((d) => (d.id === event.routerId ? updateDeviceDataAfterChangeEvent(d, event) : d)),
        };
    }),
    on(DeviceActions.updateLink, (state, { event }) => {
        return {
            ...state,
            devices: state.devices.map((d) => (d.serialNumber === event.routerSn ? updateDeviceDataAfterLinkChangeEvent(d, event) : d)),
        };
    })

    /**
     * HINT for DELETING, CREATING, UPDATING, CONNECTING, DISCONNECTING and RESERVING device:
     * Reload devices instead of updating state.devices, because of server side pagination.
     * Updating state.devices might lead to wrong display of data depending on filterParams
     */
);

export function devices(state = devicesInitialState, action: Action): DeviceState {
    return deviceReducer(state, action);
}

/**
 * Function for Updating a single Device with a ChangedEventRecieved via the SSE Endpoint
 * @param device the device from the State
 * @param event the Event that was received
 * @returns the update Device
 */
function updateDeviceDataAfterChangeEvent(device: RouterDto, event: ChangedEvent): RouterDto {
    // tslint:disable-next-line:no-object-literal-type-assertion
    const updateDevice: RouterDto = { ...device, ...event } as RouterDto;
    if (updateDevice.vpnInfo === undefined) {
        updateDevice.vpnInfo = {
            vpnIp: event.vpnIp,
            statusTime: event.statusTime,
        };
    } else {
        updateDevice.vpnInfo = {
            ...updateDevice.vpnInfo,
            vpnIp: event.vpnIp,
            statusTime: event.statusTime,
        };
    }
    return updateDevice;
}
/**
 * Function for Updating a single Device with a LinkChangedEvent received via the SSE Endpoint
 * @param device - The device from the State
 * @param event - The Event that was received
 * @returns The updated Device
 */
function updateDeviceDataAfterLinkChangeEvent(device: RouterDto, event: LinkChanged): RouterDto {
    const updateDevice: RouterDto = { ...device, ...event } as RouterDto;
    let currentUser;
    let currentUserId;

    if (event.linked === true) {
        currentUser = event.user.name;
        currentUserId = event.user.id;
    } else {
        currentUser = undefined;
        currentUserId = undefined;
    }

    if (updateDevice.vpnInfo === undefined) {
        updateDevice.vpnInfo = {
            currentUser: currentUser,
            currentUserId: currentUserId,
        };
    } else {
        updateDevice.vpnInfo = {
            ...updateDevice.vpnInfo,
            currentUser: currentUser,
            currentUserId: currentUserId,
        };
    }

    return updateDevice;
}
